/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { registerLanguage } from '../_.contribution.js';
registerLanguage({
    id: 'r',
    extensions: ['.r', '.rhistory', '.rmd', '.rprofile', '.rt'],
    aliases: ['R', 'r'],
    loader: function () { return import('./r.js'); }
});
